import React, { useState, useEffect } from "react";

import { Modal } from "@material-ui/core";
import api from "../../services/api";
import { Button } from "primereact/button";
import "./ModalEditNameEpic.css";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function ModalEditNameEpic({ isOpen, onClose, task = {}, getTasks }) {
  const [usersname, setUsersname] = React.useState([]);
  const [options, setoptions] = useState([]);
  const { id } = task;

  useEffect(() => {
    const getUsers = async () => {
      try {
        const response = await api.get("api/buscarNomeUsuarios");
        setoptions(response.data);
      } catch (error) {
        console.error("Erro ao atualizar o registro:", error);
      }
    };
    getUsers();
  }, []);

  if (!id) return null;

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setUsersname(
      
      typeof value === "string" ? value.split(",") : value
    );
  };

  const updateNameButton = async () => {
    try {
      getTasks();
      onClose();
      setUsersname([]);
    } catch (error) {
      console.error("Erro ao atualizar o registro:", error);
    }
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="Modal">
          <div className="Modal_title" id="modal-modal-title" variant="h5">
            Selecionar Usuário(s)
          </div>
          <FormControl style={{ width: "60%", marginBottom: "2rem" }}>
            <InputLabel
              style={{ marginLeft: "10px" }}
              id="demo-multiple-name-label"
            >
              Usuários
            </InputLabel>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              multiple
              value={usersname}
              onChange={handleChange}
              input={<OutlinedInput label="Escolha os usuários" />}
              MenuProps={MenuProps}
            >
              {options?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              severity="danger"
              color="secondary"
              onClick={onClose}
              outlined
            >
              Cancelar
            </Button>
            <Button
              style={{ marginLeft: ".5rem" }}
              color="primary"
              onClick={updateNameButton}
              severity="success"
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ModalEditNameEpic;
